<template>
  <div class='e-tab-wrap h-mmlTabs-content'>
    <div class='h-mml-scnrbox'>
      <form :id='formId' onsubmit="return false">
        <div class='form-group'>
          <label>{{$t('MML.fileName')}}</label>
          <div class='h-mml-upload'>
            <ejs-textbox v-model='fileName' name='mml-uadform-input' :placeholder='curPlaceholder' width='400px'></ejs-textbox>
            <div class='h-mml-upload-area'>
              <template v-if='showUPLD'>
                <div>
                  <ejs-uploader :autoUpload= 'isAuto' :id='uploadId' @selected='onFileSelect'
                    :allowedExtensions='extensions' :multiple='false' ></ejs-uploader>
                  <button type='button' class='e-control e-btn e-primary' @click="uploadFile">{{$t('MML.selectFileButton')}}</button>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-show='showEtcNeType' class='form-group'>
          <label>{{$t('MML.neType')}}</label>
          <div>
            <ejs-dropdownlist v-model='etcType' name='mml-etc-type' :fields='fields' :dataSource='type' width='400px'></ejs-dropdownlist>
          </div>
        </div>
        <div v-show='showEnbNeType' class='form-group'>
          <label>{{$t('MML.neType')}}</label>
          <div>
            <ejs-dropdownlist v-model='enbType' name='mml-enb-type' :fields='fields' :dataSource='type' width='400px'></ejs-dropdownlist>
          </div>
        </div>
      </form>
    </div>
    <div class='h-input-btns'>
      <ejs-button  class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='execMML'>{{$t('MML.execute')}}</ejs-button>
      <ejs-button  class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='generateMML2Cmd'>{{$t('MML.buildMML')}}</ejs-button>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { FormValidator } from '@syncfusion/ej2-inputs';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default ({
  data() {
    return {
      extensions: '.txt',
      isAuto: false,
      fields: { text: 'name', value: 'value' },
      fileName: '',
      etcType: '',
      enbType: '',
      formObj: '',
      type: [],
      showEnbNeType: false,
      showEtcNeType: false,
      curPlaceholder: '',
      showUPLD: false,
      options: {
        customPlacement: (inputElement, errorElement) => {
          const parentElement = inputElement.closest('.form-group');
          parentElement.appendChild(errorElement);
        },
        rules: {
          'mml-uadform-input': {
            required: [true, this.$t('MML.notNull')],
            maxLength: [255, this.$t('MML.maxLength', [255])]
          }
        }
      }
    };
  },
  props: {
    formName: {
      type: String,
      default() {
        return '';
      },
    },
  },
  mixins: [packageParams],
  mounted() {
    console.log('------mounted------')
    this.formObj = new FormValidator(`#${this.formId}`, this.options);
  },
  computed: {
    ...mapGetters(['currentNode', 'currentMo', 'currentCommand', 'mmlOperButtonDisabled']),
    // curPlaceholder() {
    //   return this.currentCommand.name === 'DLD' ? this.$t('MML.selectFile') : this.$t('MML.inputFileName');
    // },
    // showUPLD() {
    //   return this.currentCommand.name.toUpperCase() === 'DLD';
    // },
    formId() {
      return `form4mml${this.formName}`;
    },
    inputId() {
      return `uadform${this.formName}`;
    },
    uploadId() {
      return `upload${this.formName}`;
    }
  },
  methods: {
    ...mapMutations(['changeCommand']),
    setInitParams(mo, command) {
      this.formObj.element.reset();
      this.showEtcNeType = this.currentMo.moName === 'etcCfgData';

      this.showEnbNeType = this.currentMo.moName === 'eNodeBCfgData';
      if (this.showEtcNeType) {
        this.type = this.getEtcType();
      } else {
        this.type = this.getEnbType();
        // ibsb没有类型字段
        if(this.type.length <= 0){
          this.showEnbNeType = false;
        }
      }
      if(this.showEtcNeType) {
        this.formObj.addRules('mml-etc-type', { required: [true, this.$t('MML.notNull')] });
      } else if (this.showEnbNeType) {
        this.formObj.addRules('mml-enb-type', { required: [true, this.$t('MML.notNull')] });
      }
      this.curPlaceholder = command.name.toUpperCase() === 'DLD' ? this.$t('MML.selectFile') : this.$t('MML.inputFileName');
      this.showUPLD = command.name.toUpperCase() === 'DLD';
      this.changeCommand(command);
    },
    getEtcType() {
      const vals = [];
      try {
        const ranges = this.currentMo.attrMap.etcType.range;
        ranges.split(',').forEach((range) => {
          const tempVal = range.split(':');
          vals.push({
            name: tempVal[0].trim(),
            value: tempVal[0].trim()
          });
        });
      } catch (error) {
        console.warn('----etc type is undefined---');
      }
      return vals;
    },
    getEnbType() {
      const vals = [];
      try {
        const ranges = this.currentMo.attrMap.neType.range;
        ranges.split(',').forEach((range) => {
          const tempVal = range.split(':');
          vals.push({
            name: tempVal[0].trim(),
            value: tempVal[0].trim()
          });
        });
      } catch (error) {
        console.warn('----enb type is undefined---');
      }
      return vals;
    },
    onFormSubmit() {
      const formStatus = this.formObj.validate();
      if (formStatus) {
        this.formObj.element.reset();
        this.$refs.dialogObj.show();
      }
    },
    onFileSelect(args) {
      // 上传文件逻辑
      const uploadUrl = '/lte/ems/config/mml/enodeBCfgDataUpLoad';
      const formData = new FormData();
      const uploadFile = document.getElementById(this.uploadId).files[0];
      formData.append('mFile', uploadFile);
      let neid;
      if (this.currentNode.nodeType === 'equipment') {
        neid = this.findEquipmentIpId(this.currentNode, this.currentMo);
      } else {
        neid = this.currentNode.id;
      }
      formData.append('neid', neid);
      formData.append('systemid', 1);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      this.axios.post(uploadUrl, formData, config).then(res => {
        this.fileName = args.filesData[0].name;
      })
    },
    uploadFile() {
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      return false;
    },
    execMML() {
      console.log('readyToExec');
      console.log(this.options.rules);
      if (this.formObj.validate()) {
        const cmdList = this.genUadFormMML();
        this.$emit('ready-to-exec', cmdList);
      } else {
        console.warn('mml表单校验不通过');
      }
    },
    generateMML2Cmd() {
      console.log(this.options.rules);
      if (this.formObj.validate()) {
        const cmdList = this.genUadFormMML();
        bus.$emit('add2CmdEditor', cmdList);
      } else {
        console.warn('mml表单校验不通过');
      }
    },
    genUadFormMML() {
      const cmdList = [];
      const params = this.generateFormParams();
      const mml = this.parseParams2MML(params);
      cmdList.push(mml);
      return cmdList;
    },
    generateFormParams() {
      const params = {};
      params.ftpServerFileName = this.fileName;
      if (this.showEtcNeType) {
        params.etcType = this.etcType;
      } else {
        params.neType = this.enbType;
      }
      return params;
    },
    parseParams2MML(params) {
      // 匹配数值  "" ^\\d+(\.\\d+)?$
      const numberExp = new RegExp('^-?\\d+(\\.\\d+)?$');
      let mml = `${this.currentCommand.name} ${this.currentMo.moName} :`;
      if (this.currentNode) {
        mml += ` ne= ${this.currentNode.id} ,`;
      }
      if (this.currentNode.nodeType === 'equipment') {
        const equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
        mml += ` equipmentIpId= ${equipmentIpId} ,`;
      }
      Object.keys(params).forEach(param => {
        if (params[param] !== '') {
          if (numberExp.test(params[param]) || params[param] === 'null' || params[param] === '"null"') {
            mml += ` ${param} = ${params[param]},`;
          } else {
            mml += ` ${param} = "${params[param]}",`;
          }
        }
      });
      return `${mml.substring(0, mml.length - 1).trim()} ;`;
    },
  }
});
</script>
<style>

</style>
